
import React from 'react';
import { Badge } from "@/components/ui/badge";
import { Languages, DollarSign, Sun, Moon, Car, Bus, Accessibility } from 'lucide-react';

interface AdditionalInformationProps {
  place: any;
}

export function AdditionalInformation({ place }: AdditionalInformationProps) {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold flex items-center gap-2">
        <Languages className="w-5 h-5" />
        Additional Information
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {place.languages_spoken?.length > 0 && (
          <div className="flex items-center gap-2">
            <Languages className="w-4 h-4 text-muted-foreground" />
            <div className="flex flex-wrap gap-2">
              {place.languages_spoken.map((language: string) => (
                <Badge key={language} variant="secondary">
                  {language}
                </Badge>
              ))}
            </div>
          </div>
        )}

        {place.payment_methods?.length > 0 && (
          <div className="flex items-center gap-2">
            <DollarSign className="w-4 h-4 text-muted-foreground" />
            <div className="flex flex-wrap gap-2">
              {place.payment_methods.map((method: string) => (
                <Badge key={method} variant="secondary">
                  {method}
                </Badge>
              ))}
            </div>
          </div>
        )}

        {place.peak_hours && (
          <div className="flex items-center gap-2">
            <Sun className="w-4 h-4 text-muted-foreground" />
            <span>Peak hours: {place.peak_hours}</span>
          </div>
        )}

        {place.quiet_hours && (
          <div className="flex items-center gap-2">
            <Moon className="w-4 h-4 text-muted-foreground" />
            <span>Quiet hours: {place.quiet_hours}</span>
          </div>
        )}

        {place.parking_available && (
          <div className="flex items-center gap-2">
            <Car className="w-4 h-4 text-muted-foreground" />
            <span>Parking available</span>
          </div>
        )}

        {place.public_transport_access && (
          <div className="flex items-center gap-2">
            <Bus className="w-4 h-4 text-muted-foreground" />
            <span>{place.public_transport_access}</span>
          </div>
        )}

        {place.wheelchair_accessible && (
          <div className="flex items-center gap-2">
            <Accessibility className="w-4 h-4 text-muted-foreground" />
            <span>Wheelchair accessible</span>
          </div>
        )}
      </div>
    </div>
  );
}
